module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PKDE7j/tc-custom/9781452148762.jpg?1740427081544",
      "alt": "This image is the cover for the book Small Victories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Small Victories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The acclaimed cookbook author reveals the secrets to great home cooking with this cookbook featuring kitchen tips and 400+ simple recipes and variations.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Go-to recipe developer Julia Turshen is the co-author of best-selling cookbooks such as Gwyneth Paltrow’s "), _c('i', [_vm._v("It")]), _c('i', [_vm._v("’")]), _c('i', [_vm._v("s All Good")]), _vm._v(", and Dana Cowin’s "), _c('i', [_vm._v("Mastering My Mistakes in the Kitchen")]), _vm._v(", as well as the author of her own cookbooks "), _c('i', [_vm._v("Now & Again")]), _vm._v(" and "), _c('i', [_vm._v("Feed the Resistance")]), _vm._v(". In "), _c('i', [_vm._v("Small Victories")]), _vm._v(", she shares a treasure trove of kitchen tips and simple recipes you’ll return to again and again."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Julia demystifies the process of home cooking through more than a hundred “small victories”—funny and inspiring lessons she has learned through a lifetime of cooking thousands of meals. This beautifully curated, deeply personal collection emphasizes bold-flavored, honest food for breakfast, lunch, dinner, and dessert. The volume is enhanced by more than 160 mouth-watering photographs from acclaimed photographers Gentl + Hyers to follow while cooking. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julia Turshen, Ina Garten\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0